import { enumOf, useTableParams, type FieldSpec } from "@/hooks/useTableParams";
import {
  PaidStatusEnum,
  PaymentMethodTypeEnum,
} from "@/utils/enums/payroll.enum";

/** `"all"` is this table's no-filter sentinel (Radix Select forbids `""`). */
const withAll = (values: readonly string[]) => enumOf(["all", ...values]);

export interface IEarningsFilters {
  paymentMethod: PaymentMethodTypeEnum | "all";
  paidStatus: PaidStatusEnum | "all";
}

export const EARNINGS_FILTER_DEFAULTS: IEarningsFilters = {
  paymentMethod: "all",
  paidStatus: "all",
};

/**
 * URL-backed toolbar state for one earnings table.
 *
 * The Active and Hold tabs render two of these against the SAME url, so each
 * needs its own param prefix — otherwise switching tabs carries the other
 * tab's search, filters and page over.
 */
export const useEarningsParams = (holdMode: boolean) =>
  useTableParams<IEarningsFilters>({
    defaults: EARNINGS_FILTER_DEFAULTS,
    schema: {
      paymentMethod: withAll(Object.values(PaymentMethodTypeEnum)),
      paidStatus: withAll(Object.values(PaidStatusEnum)),
    } satisfies Partial<Record<keyof IEarningsFilters, FieldSpec>>,
    ns: holdMode ? "hold" : "run",
  });
